import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/data-management/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Navigate to="/data-management/energy-sourcing-and-contracts" />
}
